import { Component, Input } from '@angular/core';
import { highlight } from '@nx/js/src/utils/code-frames/highlight';

@Component({
  selector: 'ui-fh-card',
  templateUrl: './fh-card.component.html',
  styleUrls: ['./fh-card.component.scss']
})
export class FhCardComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() boxShadow: boolean = false;
  @Input() innerClass = '';
  @Input() outerClass = '';
  @Input() disabled: boolean = false;
  @Input() cardHover: boolean = false;
  @Input() highlight: boolean = false;
}
